"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_DICTATE_INTERIMS = void 0;
exports["default"] = setDictateInterims;
var SET_DICTATE_INTERIMS = 'WEB_CHAT/SET_DICTATE_INTERIMS';
exports.SET_DICTATE_INTERIMS = SET_DICTATE_INTERIMS;

function setDictateInterims(dictateInterims) {
  return {
    type: SET_DICTATE_INTERIMS,
    payload: {
      dictateInterims: dictateInterims
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfRElDVEFURV9JTlRFUklNUyIsInNldERpY3RhdGVJbnRlcmltcyIsImRpY3RhdGVJbnRlcmltcyIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2V0RGljdGF0ZUludGVyaW1zLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFVF9ESUNUQVRFX0lOVEVSSU1TID0gJ1dFQl9DSEFUL1NFVF9ESUNUQVRFX0lOVEVSSU1TJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0RGljdGF0ZUludGVyaW1zKGRpY3RhdGVJbnRlcmltcykge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFVF9ESUNUQVRFX0lOVEVSSU1TLFxuICAgIHBheWxvYWQ6IHsgZGljdGF0ZUludGVyaW1zIH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VUX0RJQ1RBVEVfSU5URVJJTVMgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLG9CQUFvQixHQUFHLCtCQUE3Qjs7O0FBRWUsU0FBU0Msa0JBQVQsQ0FBNEJDLGVBQTVCLEVBQTZDO0VBQzFELE9BQU87SUFDTEMsSUFBSSxFQUFFSCxvQkFERDtJQUVMSSxPQUFPLEVBQUU7TUFBRUYsZUFBZSxFQUFmQTtJQUFGO0VBRkosQ0FBUDtBQUlEIn0=